import { render, staticRenderFns } from "./AssignRolesForm.vue?vue&type=template&id=1ed03831&scoped=true&"
import script from "./AssignRolesForm.vue?vue&type=script&lang=js&"
export * from "./AssignRolesForm.vue?vue&type=script&lang=js&"
import style0 from "./AssignRolesForm.vue?vue&type=style&index=0&id=1ed03831&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ed03831",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1ed03831')) {
      api.createRecord('1ed03831', component.options)
    } else {
      api.reload('1ed03831', component.options)
    }
    module.hot.accept("./AssignRolesForm.vue?vue&type=template&id=1ed03831&scoped=true&", function () {
      api.rerender('1ed03831', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/global/management/vistas/components/AssignRolesForm.vue"
export default component.exports